export const SET_GUIDE = "SET_GUIDE";
export const SET_STRATEGY = "SET_STRATEGY";
export const SET_ARTICLE = "SET_ARTICLE";
export const SET_TOPIC = "SET_TOPIC";
export const SET_WORKSHOP = "SET_WORKSHOP";
export const SET_WORKSHOP_REG_STATE = "SET_WORKSHOP_REG_STATE";
export const SET_ASSESSMENT_STATE = "SET_ASSESSMENT_STATE";
export const SET_TOPICS = "SET_TOPICS";
export const SET_ARTICLES = "SET_ARTICLES";
export const SET_WORKSHOPS = "SET_WORKSHOPS";
export const SET_ASSESSMENT_DATA = "SET_ASSESSMENT_DATA";
